<template>
  <div id="hero">
    <div id="illustration">
      <img
        id="foreground"
        src="@/assets/CWHOS/CWHOS-fg-hr.png"
        alt="Can We Hang Out Sometime foreground"
      />
      <div id="title-text">CAN WE HANG OUT SOMETIME?</div>
      <a
        id="listen-now-btn"
        href="https://found.ee/GK-CWHOS?utm_medium=website"
        target="_blank"
        rel="noopener noreferrer"
        @click="trackListenNowClick"
        >LISTEN NOW</a
      >
      <a
        id="tour-btn"
        href="/tour"
        @click="trackTourClick"
        >TOUR TICKETS</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
  methods: {
    trackListenNowClick() {
      if (window.gtag) {
        window.gtag("event", "click", {
          event_category: "Button",
          event_label: "Listen to Album - Hero",
          transport_type: "beacon",
        });
      }
    },
    trackTourClick() {
      if (window.gtag) {
        window.gtag("event", "click", {
          event_category: "Button",
          event_label: "Tour Tickets - Hero",
          transport_type: "beacon",
        });
      }
    },
  },
};
</script>

<style scoped>
#hero {
  background-image: url("@/assets/CWHOS/CWHOS-bg-goop-nav.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  z-index: -1;
  display: flex;
  align-items: center;
  justify-content: center;
}

#illustration {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
}

#foreground {
  max-height: 80%;
  max-width: 170%;
  object-fit: contain;
  filter: drop-shadow(0 0 40px rgba(255, 255, 255, 0.8))
    drop-shadow(0 0 80px rgba(255, 255, 255, 0.5));
}

#title {
  max-width: 100%;
  width: 1200px;
  max-height: 203%;
  -o-object-fit: contain;
  object-fit: contain;
  margin-top: -7.5rem;
}

#title-text {
  font-size: 50px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 -40px 100px, 0 0 2px, 0 0 1em #000000, 0 0 0.5em #ffffff,
    0 0 0.1em #7a008a, 0 10px 18px #000;
  text-align: center;
  margin-top: -3.5rem;
  font-family: sans-serif;
}

#listen-now-btn {
  background-color: #e070f2;
  font-weight: 700;
  color: #ffffff;
  text-decoration: none;
  text-align: center;
  margin-top: 2rem;
  font-size: 30px;
  padding: 12px 24px;
  cursor: pointer;
  border-radius: 4px;
  min-width: 280px;
}

#listen-now-btn:hover {
  opacity: 0.9;
}

#tour-btn {
  background: linear-gradient(
    90deg,
    #ff6b6b 0%,
    #feca57 25%,
    #48dbfb 50%,
    #ff9ff3 75%,
    #ff6b6b 100%
  );
  background-size: 200% 100%;
  animation: gradient-shift 3s linear infinite;
  font-weight: 700;
  color: #ffffff;
  text-decoration: none;
  text-align: center;
  margin-top: 1rem;
  font-size: 30px;
  padding: 12px 24px;
  cursor: pointer;
  border-radius: 4px;
  min-width: 280px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

#tour-btn:hover {
  opacity: 0.8;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: -200% 50%;
  }
}

@media (max-width: 768px) {
  #title-text {
    font-size: 36px;
    margin-top: 0;
  }
}
</style>
